var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sapling-list-numbering"},[(_vm.showLegend)?_c('span',{staticClass:"sapling-list-numbering_legend"},[_vm._v("#")]):_vm._e(),_c('ul',_vm._l((_vm.saplingGeneList),function(saplingGenes,index){return _c('li',{key:index,staticClass:"sapling-list-numbering_number",class:{
        'sapling-list-numbering_number--special': index !== 0 && index % 6 === 0 && _vm.showSpecial
      }},[_vm._v(" "+_vm._s(index + 1)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }